/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika est désormais une génisse. Elle ingurgite chaque jour près de 80 kilos de
fourrage, 2 kilos d’aliment concentré et un peu de sel. Elle boit entre 50 et 100
litres d’eau par jour. Près de 70% de la surface agricole de Suisse est utilisée
pour la production de fourrage, y compris prés et pâturages où paissent les
vaches. Sur la surface nécessaire à produire un kilo de viande, on peut, dans
le même laps de temps, faire pousser 200 kilos de tomates ou 160 kilos de pommes
de terre. Autrement dit: un steak occupe la même surface cultivable que 386 carottes.`}</p>
    <Image file={['flaechenverbrauch-fr-01.png', 'flaechenverbrauch-fr-02.png']} title='Utilisation du terrain' subtitle='par kilo de nourriture' source='Source: www.swissveg.ch' mdxType="Image" />
    <p>{`Actuellement, on dénombre 1,5 million de bovins en Suisse. Lorsque des ruminants
digèrent leur nourriture, et lorsqu’on épand le fumier de vache comme engrais naturel
sur les prés ou les champs, cela produit du méthane. C’est un gaz à effet de serre. 11%
des émissions de gaz à effet de serre proviennent de l’agriculture, dont 40% sont
produits par les bovins ruminants.`}</p>
    <Image file={'emissionen-fr.png'} title='Pourcentage de l’élevage bovin' subtitle='des émissions anthropiques en Suisse' source='Source: DEFR - Département fédéral suisse de l’économie, de l’éducation et de la recherche' mdxType="Image" />
    <p>{`Une vache laitière dégage chaque année 7 tonnes d’équivalent CO`}<sub>{`2`}</sub>{`, ce qui
correspond à un aller/retour d’un passager en classe économique de Genève à Melbourne
en Australie. Sachant qu’il y a 560’000 vaches laitières vivant en Suisse, elles
sont à l’origine d’autant de CO`}<sub>{`2`}</sub>{` que 1456 Boeing 77 de la compagnie Swiss avec
340 passagers sur un vol Genève-Melbourne aller/retour.`}</p>
    <Image file={'kueheundboeings-fr.png'} source='www.myclimate.org' mdxType="Image" />
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  